import { useAtom } from "jotai";
import { SIDE_NAV_WIDTH } from "../consts";
import { sideNavOnAtom } from "../jotai/atoms";

// CANVAS_RECT contain coordinate information in respect to the document.
const CANVAS_RECT = {
  top: 0,
  left: 0,
};

export function setCanvasOffset(offset: { top: number; left: number }) {
  CANVAS_RECT.top = offset.top;
  CANVAS_RECT.left = offset.left;
}

/**
 * canvasPos translate position data that use document as frame of reference
 * to using canvas as a frame of reference
 *
 * @param mouse - mouse position in respect the document
 * @returns position (in pixel unit) using canvas as a frame of reference
 */
export function canvasPos(mouse: { pageX: number; pageY: number }) {
  return {
    x: mouse.pageX - CANVAS_RECT.left,
    y: mouse.pageY - CANVAS_RECT.top,
  };
}

export function useSetupCanvasPos() {
  const [sideNavOn] = useAtom(sideNavOnAtom);

  const offset = sideNavOn
    ? { left: SIDE_NAV_WIDTH, top: 0 }
    : { left: 0, top: 0 };

  setCanvasOffset(offset);
}
